import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import {VehicleCardComponent} from '../vehicle-card/vehicle-card.component';
import {
  AddVehicleToSelections,
  ClearAllSelectedVehicles,
  ConfigurationState,
  RemoveVehicleFromSelections,
  StatusFilter
} from 'remarketing-angular-library';
import {
  SharedListMultiActionModalComponent
} from '../../../../../shared/components/offer-modals/shared-list-multi-action-modal/shared-list-multi-action-modal.component';
import {
  PurchaseOfferHistoryModalComponent
} from '../../../../../shared/components/offer-modals/purchase-offer-history-modal/purchase-offer-history-modal.component';
import {
  PostingHistoryModalComponent
} from '../../../../../shared/components/offer-modals/posting-history-modal/posting-history-modal.component';
import {
  EditListingGroundModalComponent
} from '../edit-listing-ground-modal/edit-listing-ground-modal.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import {
  StateIndicatorComponent
} from '../../../../../shared/components/state-indicator/state-indicator.component';
import {
  TooltipComponent,
  TrackButtonDirective,
  TrapFocusComponent
} from 'remarketing-ui-components-lib';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {
  ActionListMessageModalComponent
} from '../action-list-modals/action-list-message-modal/action-list-message-modal.component';
import {
  MakeReserveModalComponent
} from '../action-list-modals/make-reserve-modal/make-reserve-modal.component';
import {
  MakeUnreserveModalComponent
} from '../action-list-modals/make-unreserve-modal/make-unreserve-modal.component';

@Component({
    selector: '[list-view-inventory-item]',
    templateUrl: './list-view-inventory-item.component.html',
    styleUrls: ['./list-view-inventory-item.component.scss'],
    imports: [
        SharedListMultiActionModalComponent,
        PurchaseOfferHistoryModalComponent,
        PostingHistoryModalComponent,
        EditListingGroundModalComponent,
        CommonModule,
        RouterLink,
        StateIndicatorComponent,
        TrapFocusComponent,
        PopoverModule,
        TooltipComponent,
        TrackButtonDirective,
        ActionListMessageModalComponent,
        MakeReserveModalComponent,
        MakeUnreserveModalComponent
    ]
})
export class ListViewInventoryItemComponent extends VehicleCardComponent implements OnInit, OnChanges {
  @Input() singleListSelected: boolean;
  @Input() hadMultiOfferActionSuccess: boolean;
  @Input() isFilterByInServiceVehicles = false;
  @Output() modalEvent = new EventEmitter<any>();
  @ViewChild('kabobPopOver') popover;
  @ViewChild(SharedListMultiActionModalComponent) sharedListMultiActionModal: SharedListMultiActionModalComponent;
  @ViewChild(EditListingGroundModalComponent) editListingGroundModal: EditListingGroundModalComponent;
  @ViewChild(PurchaseOfferHistoryModalComponent) purchaseOfferHistoryModal: PurchaseOfferHistoryModalComponent;
  @ViewChild(PostingHistoryModalComponent) postingHistoryModal: PostingHistoryModalComponent;

  modalMessage: string[] = [];
  modalRef: BsModalRef;
  modalConfig: any;

  private readonly IN_SERVICE_VEHICLE = 'ISV';
  userType = 'SELLER';
  hadOfferActionTaken: boolean;
  vehicleIsGrounded: boolean;
  protected configStateTenantName = '';
  analyticsObject = {
    reserve: {
      buttonName: 'Reserve',
      modalName: 'Reserve Vehicle Modal'
    },
    changeReserved: {
      buttonName: 'Change Reserved Dealership',
      modalName: 'Reserve Vehicle Modal'
    },
    unreserve: {
      buttonName: 'Unreserve',
      modalName: 'Unreserve Vehicle Modal'
    }
  };

  closePopover() {
    this.popover.hide();
  }

  auctionItemStatusEqualTo(status: StatusFilter) {
    return this.auctionItemSell.auctionItemStatus === status;
  }

  groundedValueChanged(event) {
    const groundedDate = event.data.inventoryItem.groundedDate;
    groundedDate ? this.groundedSubject.next(true) : this.groundedSubject.next(false);
  }

  get isInspectionSeriesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inspectionSeriesEnabled', false);
  }

  get isChangeReservedDealershipEnabled() {
    return this.launchDarklyService.getFeatureFlag('sell-changeReservedDealerEnabled', false);
  }

  get totalPrice() {
    return (
      (this.auctionItemSell.salePrice ? this.auctionItemSell.salePrice : this.auctionItemSell?.offerAmount) +
      this.auctionItemSell?.buyFee.total
    );
  }

  get showQuestionsValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.filterByStatusSelected === StatusFilter.ACTIVE_VEHICLES ||
        (this.filterByStatusSelected === StatusFilter.SHARED_VEHICLES &&
          this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES)
      );
    }
  }

  get showOffersValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.filterByStatusSelected === StatusFilter.ACTIVE_VEHICLES ||
        (this.filterByStatusSelected === StatusFilter.SHARED_VEHICLES &&
          this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES)
      );
    }
  }

  get showHighestOfferValue() {
    if (!this.isVehicleTypeFilterISV) {
      return this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES && this.highestOffer;
    }
  }

  get showBuyNowValue() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES && this.auctionItemSell.buyNowAmount
      );
    }
  }

  get showOpeningPriceValue() {
    return !this.isVehicleTypeFilterISV
      ? this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES
      : this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES ||
          this.auctionItemSell.auctionItemStatus === StatusFilter.RESERVED_VEHICLES ||
          this.auctionItemSell.auctionItemStatus === StatusFilter.SOLD_VEHICLES ||
          this.auctionItemSell.auctionItemStatus === StatusFilter.HOLD_VEHICLES ||
          this.auctionItemSell.auctionItemStatus === StatusFilter.REMOVED_VEHICLES;
  }

  get showSaleFeeAndSalePriceColumn() {
    if (!this.isVehicleTypeFilterISV) {
      return (
        this.filterByStatusSelected === StatusFilter.SHARED_VEHICLES ||
        this.filterByStatusSelected === StatusFilter.SOLD_VEHICLES
      );
    }
  }

  get showSaleFeeAndSalePriceValue() {
    return this.auctionItemSell.auctionItemStatus === StatusFilter.SOLD_VEHICLES && this.auctionItemSell.salePrice;
  }

  get showTotalPriceValue() {
    return this.auctionItemSell.salePrice || this.auctionItemSell?.offerAmount;
  }

  get showTotalPriceColumn() {
    if (!this.isVehicleTypeFilterISV) {
      return this.filterByStatusSelected === StatusFilter.SHARED_VEHICLES && this.singleListSelected;
    }
  }

  get showActionsDropdown() {
    return (
      this.auctionItemSell.auctionItemStatus !== StatusFilter.EXPIRED_VEHICLES &&
      this.auctionItemSell.auctionItemStatus !== StatusFilter.REMOVED_VEHICLES &&
      this.auctionItemSell.auctionItemStatus !== StatusFilter.HOLD_VEHICLES
    );
  }

  get showListViewCheckbox() {
    return this.showActionBarCheckbox && !this.hadOfferActionTaken;
  }

  get showGroundedColumn() {
    return this.filterByStatusSelected === StatusFilter.RESERVED_VEHICLES;
  }

  ngOnInit() {
    this.hadOfferActionTaken = this.hadMultiOfferActionSuccess;
    super.ngOnInit();
    this.getTenantName();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hadMultiOfferActionSuccess && !changes.hadMultiOfferActionSuccess.isFirstChange()) {
      if (!this.hadOfferActionTaken) {
        this.hadOfferActionTaken = changes.hadMultiOfferActionSuccess.currentValue;
        this.store.dispatch(new RemoveVehicleFromSelections(this.auctionItemSell));
      }
      this.showAvailableMultiActions();
    }
  }

  showOfferActionButton(offerAction) {
    return this.sellerActionMapCounter.get(offerAction) === 1;
  }

  showPurchaseOfferHistoryModal() {
    this.purchaseOfferHistoryModal.show();
  }

  showPostingHistoryModal() {
    this.postingHistoryModal.show();
  }

  get showListViewPostingHistoryButton(): boolean {
    return this.isRemovedActionsEnabled && this.auctionItemSell.removalCount > 1;
  }

  get showListViewRepostButton(): boolean {
    return this.isRemovedActionsEnabled && !this.auctionItemSell.repostedDate && !this.isVinDecodeRequired();
  }

  get showListViewActionsDropdown(): boolean {
    if (this.inServiceVehiclesEnabled) {
      return this.isInServiceVehicle && this.isNotSoldOrRemoved;
    } else {
      return this.showActionElipsisForGenericTenantVehicle;
    }
  }

  get isInServiceVehicleOrReservationsEnabled(): boolean {
    return this.inServiceVehiclesEnabled || this.isReservationsEnabled;
  }

  get isInServiceVehicle(): boolean {
    return this.auctionItemSell?.vehicleTypeCode === this.IN_SERVICE_VEHICLE;
  }

  get isNotSoldOrRemoved(): boolean {
    const auctionItemStatus = this.auctionItemSell?.auctionItemStatus;
    return auctionItemStatus !== 'SOLD' && auctionItemStatus !== 'REMOVED' && auctionItemStatus !== 'EXPIRED';
  }

  get isReserved(): boolean {
    const reservationDate = this.auctionItemSell?.reservation?.reservedAt;
    return reservationDate !== null && reservationDate !== undefined && reservationDate.length > 0;
  }

  get showActionElipsisForGenericTenantVehicle(): boolean {
    if (
      this.auctionItemStatusEqualTo(this.statusFilter.REMOVED_VEHICLES) ||
      this.auctionItemStatusEqualTo(this.statusFilter.EXPIRED_VEHICLES)
    ) {
      return this.showListViewPostingHistoryButton || this.showListViewRepostButton;
    }
    return true;
  }

  get reserveStatus() {
    return this.listViewTableTranslations.textReserve;
  }

  showMultiActionModal(modalType: string) {
    this.sharedListMultiActionModal.show(modalType, [this.auctionItemSell]);
  }

  showEditListingGroundModal(modalType: string) {
    this.editListingGroundModal.show(modalType, this.auctionItemSell);
  }

  createBanners(event) {
    this.sharedListMultiActionModal.close();
    this.modalEvent.emit(event);
  }

  formatStorageLocation() {
    if (this.auctionItemSell.storageLocation?.city && this.auctionItemSell.storageLocation?.state) {
      const city = this.auctionItemSell.storageLocation.city;
      const state = this.auctionItemSell.storageLocation.state;
      return city + ', ' + state;
    } else {
      return null;
    }
  }

  openModal(template, analyticsTranslations) {
    // Clear any prior selections since this action should only impact one vehicle at a time.
    this.store.dispatch([new ClearAllSelectedVehicles(), new AddVehicleToSelections(this.auctionItemSell)]);

    if (analyticsTranslations.buttonName) {
      this._analyticsService.fireEventOnButtonClick(analyticsTranslations.buttonName);
    }

    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.modalConfig = {
      class: 'modal--manage-inventory-action',
      backdrop: 'static',
      keyboard: false
    };

    this.modalRef = this.bsModalService.show(template, this.modalConfig);

    this.trackModalView(`${this.configStateTenantName}: ${analyticsTranslations.modalName}`);
  }

  onModalMessage($event, template) {
    this.modalMessage = $event;
    this.modalRef.hide();
    this.modalConfig = {
      class: 'modal--manage-inventory-action',
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.bsModalService.show(template, this.modalConfig);
  }

  onModalClose() {
    this.modalRef.hide();
    // Clear selected vehicles on a slight delay so that the vehicles are deselected after the close animation
    setTimeout(() => {
      this.store.dispatch(new ClearAllSelectedVehicles());
    }, 400);
  }

  getTenantName() {
    this.configStateTenantName = this.store.selectSnapshot(ConfigurationState.tenantName);
  }

  trackModalView(modalName) {
    try {
      this._analyticsService.track('modalView', modalName);
    } catch(e) {
      console.error(e);
    }
  }
}
